import ApiService from './api.service';

class AuthenticationError extends Error {
  constructor (errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const CompanyService = {
  createJob: async function (body) {
    let url = `${process.env.VUE_APP_BASE_URL}/empresa/trabajo/crear`;
    let jobResponse = await ApiService.post(url, body);
    return jobResponse.data;
  },

  uploadPhoto: async function (photoFile) {
    const url = ApiService.getEndpoint('/empresa/actualizarLogo');
    let formData = new FormData();
    formData.append('logoFile', photoFile);
    let response = await ApiService.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    console.log(response);
    return response.data;
  }
};

export default CompanyService;

export { CompanyService, AuthenticationError };
